module.exports = __webpack_public_path__ + "static/assets/58f9a929b1614e8d05e02496b4b3205c.png";